import { render, staticRenderFns } from "./syncNote.vue?vue&type=template&id=28dea1aa&scoped=true&"
import script from "./syncNote.vue?vue&type=script&lang=js&"
export * from "./syncNote.vue?vue&type=script&lang=js&"
import style0 from "./syncNote.vue?vue&type=style&index=0&id=28dea1aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dea1aa",
  null
  
)

export default component.exports